const limit={
    bind(el, { value }) {
        const input=el.getElementsByTagName('input')[0]
        let lastval=0;
        input.onkeyup=function (e) {


            if (input.value< -200||input.value>1000) {
                input.value=lastval;
            } else {
                lastval=input.value;
            }
            trigger(input, 'input')
        }
        input.onblur=function (e) {
            if (input.value< -200||input.value>1000) {
                input.value=lastval;
            } else {
                lastval=input.value;
            }
            trigger(input, 'input')
        }

    }, // 指令与元素解绑的时候，移除事件绑定
    unbind(el) {
        el.removeEventListener('click', el.handler)
    },
}
const trigger=(el, type) => {
    const e=document.createEvent('HTMLEvents')
    e.initEvent(type, true, true)
    el.dispatchEvent(e)
}

export default limit



// WEBPACK FOOTER //
// ./src/common/directives/limit.js